import { Stack, Text, VStack } from 'native-base';
import { TableCellWithAvatar } from 'ui/components/TableCellWithAvatar';

import MenuList from '~/components/MenuList';
import { MenuItem } from './types';
import useDrawerController from './controller';

interface DrawerProps {
  menuItems?: MenuItem[];
}

const Drawer = ({ menuItems = [] }: DrawerProps) => {
  const { currentOrganization } = useDrawerController();

  return (
    <>
      <Stack
        w="200px"
        zIndex={1}
        background="white"
        alignItems="start"
        justifyContent="space-between"
      >
        <VStack w="full" mb={5} pt={12}>
          <Stack px={6}>
            <TableCellWithAvatar avatar={currentOrganization?.logo} name={''} />
          </Stack>
          <Stack mt={1} px={6}>
            <Text
              color="gray.500"
              fontWeight={500}
              fontSize="lg"
              textAlign={'start'}
            >
              {currentOrganization?.name}
            </Text>
          </Stack>
          <Stack w="full">
            <MenuList menuItems={menuItems} />
          </Stack>
        </VStack>
      </Stack>
    </>
  );
};

export default Drawer;
